﻿window.cObjetDocCptSocieteMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Société"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvelle société"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data.nom == 'undefined' || objet.data.nom == null || objet.data.nom.length == 0) { txt = "..." }
        else {
            txt = objet.data.nom
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-building-columns' title='société'></i>");
    }

    this.mGetTelMiseEnforme = function () {
        if (objet.data.tel_sms != null && objet.data.tel_sms.length > 0) {
            var tel = new cTelephone(objet.data.tel_code_pays, objet.data.tel_sms)
            return tel.mGetValueMiseEnForme()
        } else { return "" }
    }

}